'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class;

var _reactRedux = require('react-redux');

var _modal = require('redux/actions/modal');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    AlcoModal: {
        displayName: 'AlcoModal'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/Basket/AlcoModal.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var AlcoModal = _wrapComponent('AlcoModal')((_dec = (0, _reactRedux.connect)(function (state) {
    return {
        settings: state.setting,
        lang: state.lang
    };
}, {
    hide: _modal.hide
}), _dec(_class = function (_Component) {
    (0, _inherits3.default)(AlcoModal, _Component);

    function AlcoModal() {
        (0, _classCallCheck3.default)(this, AlcoModal);
        return (0, _possibleConstructorReturn3.default)(this, (AlcoModal.__proto__ || (0, _getPrototypeOf2.default)(AlcoModal)).apply(this, arguments));
    }

    (0, _createClass3.default)(AlcoModal, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                settings = _props.settings,
                lang = _props.lang;


            var firstLineStart = lang['store.alco_modal.notification.start'];
            var firstLineEnd = lang['store.alco_modal.notification.end'];
            var firstLine = firstLineStart + ' "' + settings.shopName + '" ' + firstLineEnd;

            return _react3.default.createElement(
                'div',
                null,
                _react3.default.createElement(
                    'p',
                    null,
                    firstLine
                ),
                _react3.default.createElement(
                    'p',
                    null,
                    lang['store.alco_modal.buy_offline']
                ),
                _react3.default.createElement(
                    'p',
                    null,
                    lang['store.alco_modal.remove_alco']
                )
            );
        }
    }]);
    return AlcoModal;
}(_react2.Component)) || _class));

exports.default = AlcoModal;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Basket/AlcoModal.jsx
// module id = 746
// module chunks = 0